import { isNil, isArray, intersection } from 'lodash';

export function pushAxisDimensionSafelyInConfig(config, elementToBePushed, options = { clearBeforePush: false }) {
	if (options.clearBeforePush || isNil(config.axisDimensions) || !isArray(config.axisDimensions))
		config.axisDimensions = [];

	if (!isArray(elementToBePushed))
		elementToBePushed = [ elementToBePushed ];

	elementToBePushed.forEach(el => {
		if (!isNil(el) && !config.axisDimensions.some(x => x.name === el.name))
			config.axisDimensions.push(el);
	});
}

export function pushLegendDimensionSafelyInConfig(config, elementToBePushed, options = { clearBeforePush: false }) {
	if (options.clearBeforePush || isNil(config.legendDimensions) || !isArray(config.legendDimensions))
		config.legendDimensions = [];

	if (!isArray(elementToBePushed))
		elementToBePushed = [ elementToBePushed ];

	elementToBePushed.forEach(el => {
		if (!isNil(el) && !config.legendDimensions.some(x => x.name === el.name))
			config.legendDimensions.push(el);
	});
}

export function pushMeasuresDimensionSafelyInConfig(config, elementToBePushed) {
	if (isNil(config.measures) || !isArray(config.measures))
		config.measures = [];
	if (!isArray(elementToBePushed))
		elementToBePushed = [ elementToBePushed ];

	elementToBePushed.forEach(el => {
		if (!isNil(el) && !config.measures.some(x => x.name === el.name))
			config.measures.push(el);
	});
}

export function removeDimensionFromAxisIfPresent(config, selectedDimensions) {
	if (isNil(config.axisDimensions) || !isArray(config.axisDimensions) || isNil(selectedDimensions) || !isArray(selectedDimensions) || selectedDimensions.length === 0)
		return;

	const dimensionsPresentInsideAxis = intersection(
		selectedDimensions.map(x => x.name),
		config.axisDimensions.map(x => x.name)
	);

	if (!isNil(dimensionsPresentInsideAxis) && isArray(dimensionsPresentInsideAxis) && dimensionsPresentInsideAxis.length > 0) {
		dimensionsPresentInsideAxis.forEach(element => {
			const index = config.axisDimensions.findIndex(ad => ad.name === element);
			if (index >= 0) {
				config.axisDimensions.splice(index, 1);
			}
		});
	}
}
